import React from 'react';

const Help = () => {
    return (
        <div>
            this is help 
        </div>
    );
};

export default Help;